import { HStack, VStack } from '@cbhq/cds-web/layout';
import { TextTitle2 } from '@cbhq/cds-web/typography';

import { Chart } from ':cloud/widgets/monitoring/Chart';
import { defaultChart, productCharts } from ':cloud/widgets/monitoring/monitoringConfig';

export function ProjectDashboardMonitoring() {
  return (
    <VStack spacing={7} borderedTop>
      <HStack spacingBottom={3} justifyContent="space-between">
        <TextTitle2 as="h2">Metrics</TextTitle2>
      </HStack>
      <VStack gap={2}>
        <Chart {...defaultChart.default_api_requests.charts[0]} range={30} />
        <Chart {...productCharts.base.charts[0]} range={30} />
      </VStack>
    </VStack>
  );
}
